import { getStoredItem } from "../../config/storageUtils";
import { useAuth } from "../Auth/AuthProvider";
import Footer from "../common/Footer";
import Sidebar from "../common/Sidebar";
import Topbar from "../common/Topbar";

const DashboardLayout = ({ children, pageTitle, mainClass }) => {
  const { userType, setUserType } = useAuth() || "user";
  function toggleSidebar() {
    const sidebar = document.getElementById("sidebar");
    const overlay = document.getElementById("overlay");
    const isOpen = !sidebar.classList.contains("-translate-x-full");
    if (isOpen) {
      sidebar.classList.add("-translate-x-full");
      overlay.classList.add("hidden");
    } else {
      sidebar.classList.remove("-translate-x-full");
      overlay.classList.remove("hidden");
    }
  }

  return (
    <div className="bg-[#f1fbfd] text-gray-800 font-sans">
      <div className="flex min-h-screen">
        <div
          id="overlay"
          className="fixed inset-0 bg-black bg-opacity-30 z-10 hidden md:hidden"
          onClick={toggleSidebar}
        ></div>
        <Sidebar />
        <div className="flex-1 flex flex-col max-w-full overflow-x-auto">
          <Topbar
            toggleSidebar={toggleSidebar}
            pageTitle={pageTitle}
            showLanguageToggle={userType === "user"}
          />
          <main className={mainClass || "p-6"}>{children}</main>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default DashboardLayout;
